<script lang="ts">

    import {fly} from 'svelte/transition';
    import {flip} from 'svelte/animate';


    export let id: string;
    export let style: string;
    export let maxWidth: number;
    export let images = [];
    export let imageURL: string;
    export let productHover: boolean;

    let isDoneSliding = true;
    let isFirstOrLastLoad = true;
    let index = 0;
    let directionProduct = 1; // 1 or -1
    let promiseInterval;
    let resetIndexIntervalID;
    let tempMainURL;

    $: productImages = images

    $: if (productImages?.length === 0) {
        productImages?.push(imageURL);
    }

    const nextImage = () => {
        if (!isDoneSliding) {
            return;
        }
        if (directionProduct > 0) {
            index = (index + 1) % productImages.length;
        } else {
            index = index > 0 ? index - 1 : productImages.length - 1;
        }
    }

    const reset = () => {
        if (isDoneSliding) {
            index = 0;
            clearInterval(resetIndexIntervalID);
        }
    }

    const onMouseLeave = async () => {
        let id = await promiseInterval;
        clearInterval(id);
        resetIndexIntervalID = setInterval(reset, 1000);
    }

    const setDirection = async (direction: "left" | "right") => {
        isFirstOrLastLoad = false;
        clearInterval(resetIndexIntervalID);
        let id = await promiseInterval;
        if (isDoneSliding) {
            directionProduct = direction === "left" ? 1 : -1;
        }
        clearInterval(id);
        promiseInterval = new Promise((resolve) => {
            if (isDoneSliding) {
                setTimeout(nextImage, 100);
            }
            directionProduct = direction === "left" ? 1 : -1;
            let id = setInterval(nextImage, 800);
            resolve(id);
        });
    }

    const markerClicked = (markerNumber: number) => {
        isFirstOrLastLoad = false;
        if (isDoneSliding) {
            let newIndex = productImages.length - markerNumber - 1;
            directionProduct = newIndex >= index ? 1 : -1;
            setTimeout(() => {
                index = newIndex;
            }, 100);
        }
    }


</script>

<svelte:head>
    {#each productImages as src}
        <link rel="preload" as="image" href={src}>
    {/each}
</svelte:head>

{#key id}
    <span class="wrapper" on:mouseleave|stopPropagation|preventDefault={onMouseLeave}>
        {#each [productImages[index]] as src (index)}
            <img class="image" src={productHover ? src : productImages[0]} alt=""
                 style={style}
                 animate:flip
                 in:fly="{!isFirstOrLastLoad ? { x: (directionProduct*(maxWidth+10)), duration: productHover ? 800 : 0, opacity: 1, delay: 200} : { x: 0, duration: 0, opacity: 0, delay: 0}}"
                 out:fly="{!isFirstOrLastLoad ? { x: (directionProduct*(-maxWidth-10)), duration: productHover ? 800 : 0, opacity: 1, delay: 200} : { x: 0, duration: 0, opacity: 0, delay: 0}}"
                 on:introstart="{() => {isDoneSliding = false}}"
                 on:outtrostart="{() => isDoneSliding = false}"
                 on:introend="{() => {isDoneSliding = true}}"
                 on:outtroend="{() => isDoneSliding = true}"/>
        {/each}
        <span class="direction left-direction"
              on:mouseenter|stopPropagation|preventDefault={() => setDirection('left')}></span>
        <span class="direction right-direction"
              on:mouseenter|stopPropagation|preventDefault={() => setDirection('right')}></span>
        {#if productImages.length > 1 && productHover}
                <span class="markers">
                    {#each {length: productImages.length} as _, i}
                        <span class="marker-wrapper">
                            <span class="marker" class:marker-hover={i !== productImages.length - index -1}
                                  class:selected-marker={i === productImages.length - index - 1}
                                  on:click|stopPropagation|preventDefault={() => markerClicked(i)}></span>
                        </span>
                    {/each}
                </span>
            {/if}
    </span>
{/key}

<!--suppress CssUnresolvedCustomProperty -->
<style>

    .image {
        width: 100%;
        height: 100%;
        image-rendering: -webkit-optimize-contrast;
        transition: all .3s linear
    }

    .wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        align-items: center;
    }

    .direction {
        width: 50%;
        height: 90%;
        position: absolute;
    }

    .left-direction {
        left: 0;
    }

    .right-direction {
        right: 0;
    }

    .markers {
        display: flex;
        position: absolute;
        width: 100%;
        bottom: 10px;
        justify-content: center;
        flex-wrap: nowrap;
        align-items: center;
        cursor: default;
    }

    .marker-wrapper {
        height: 12px;
        width: 12px;
        background-color: transparent;
        border-radius: 50%;
        border: 1px solid transparent;
        margin-right: 1px;
        margin-left: 1px;
        display: grid;
        justify-content: space-around;
        align-content: space-evenly;
    }

    .marker {
        height: 10px;
        width: 10px;
        background-color: white;
        border-radius: 50%;
        border: 1px solid black;
        margin-right: 1px;
        margin-left: 1px;
        transition: all .3s linear
    }

    .marker-hover:hover {
        opacity: 0.8;
        background-color: #c9defe;
        cursor: pointer;
    }


    .selected-marker {
        border-color: white;
        background-color: black;
        transform: scale(1.2);
        transition: all .3s linear;
    }

</style>